import React, { useState, useEffect, useReducer } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { Link, useNavigate } from 'react-router-dom'
import Header from '../../header/Header'
import Footer from '../../footer/Footer'
import ScrollView from 'devextreme-react/scroll-view';
import { useParams } from 'react-router-dom';
import * as action from '../../../actions/kaizen';
import kaizenReducer from '../../../reducers/kaizen';
import { Button } from 'devextreme-react/autocomplete';

const initialState = { ciList: [] }
const CIList = props => {
    const { category, site, query } = useParams();
    const navigate = useNavigate()
    const [animate, setAnimate] = useState('');
    const [state, dispatch] = useReducer(kaizenReducer, initialState)
    const { ciList } = state
    //"My-Kaizen",  "My-Approvals" ,"ALL"

    useEffect(() => {
        if (query === "mykaizens") {
            action.getKaizenCIList(dispatch, site, "My-Kaizens")
        }
        if (query === "myapprovals") {
            action.getKaizenCIList(dispatch, site, "My-Approvals")
        }
        if (query === "all") {
            action.getKaizenCIList(dispatch, site, "ALL")
        }
    }, [query])


    useEffect(() => {
        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    }, []);

    const scrollConfig = {
        showScrollbar: 'always',
        scrollByContent: false,
        scrollByThumb: true,
    }

    const gridConfig = {
        showBorders: true,
        rowAlternationEnabled: true,
        allowColumnReordering: true,
        allowColumnResizing: true,
        columnResizingMode: "widget",
        columnAutoWidth: true,
        columnChooser: {
            enabled: true,
            allowSearch: true,
            mode: "select"
        },

        headerFilter: {
            visible: true
        },
        sorting: {
            mode: "multiple"
        },
        grouping: {
            contextMenuEnabled: true
        },
        searchPanel: {
            visible: true
        },
        filterRow: {
            visible: true,
            applyFilter: "auto"
        },
        export: {
            enabled: true,
            fileName: "People"
        },
        editing: {
            mode: 'batch',
            allowUpdating: false,
            allowAdding: false,
            allowDeleting: false,
            useIcons: true
        },
        onToolbarPreparing: function (e) {
            var dataGrid = e.component;
            var toolbarItems = e.toolbarOptions.items;
            // Adds a new item
            toolbarItems.unshift({
                location: "before",
                template: ""
            }, {
                location: "after",
                widget: "dxButton",
                options: {
                    icon: "refresh",
                    hint: "Refresh",
                    onClick: function () {
                        dataGrid.refresh();
                    }
                }
            });
        }
    }

    const redirect = (id) => {
        navigate(`/siteApp/${category}/${site}/kaizen/editci/${query}/${id}`)
    }

    const cellRenderStatus = (data) => {
        let statusText = data.data.status
        if (statusText === "Pending Approval") {
            return <span style={{ background: "#FBFA23" }} className="stateTxt">{statusText}</span>
        }
        if (statusText === "In Progress") {
            return <span style={{ background: "#FFC627" }} className="stateTxt">{statusText}</span>
        }
        if (statusText === "Rejected") {
            return <span style={{ background: "#FF5D5D" }} className="stateTxt">{statusText}</span>
        }
        if (statusText === "Completed") {
            return <span style={{ background: "#00FF00" }} className="stateTxt">{statusText}</span>
        }
    }

    return (
        <>
            <Header showPinBtn={false} site={[]} />

            <section className="page-content">
                <div className="site-view tier-wrap admin-console-wrapper">
                    <div className={"site-list " + animate}>
                        <div className="breadcrumb">
                            <span className="icon icon-corporate"></span>
                            <ul>
                                <li><Link to={`/`}>Home</Link></li>
                                <li><Link to={`/siteApp/${category}/${site}/kaizen`}>Kaizen</Link></li>
                                {query === "mykaizens" && <li>My Kaizens</li>}
                                {query === "myapprovals" && <li>My Approvals</li>}
                                {query === "all" && <li>All Kaizens</li>}
                            </ul>
                        </div>

                        <div className="raiseci-section">
                            <div className="page-heading">
                                {query === "mykaizens" && <h2> <span className="icon kaizenIdea" ></span> My Kaizens</h2>}
                                {query === "myapprovals" && <h2> <span className="icon kmyapproval" ></span> My Approvals</h2>}
                                {query === "all" && <h2> <span className="icon kaizenIdea" ></span> All Kaizens</h2>}
                            </div>
                            <div>
                                Total : <b>{ciList.length}</b>
                            </div>
                        </div>

                        <ScrollView {...scrollConfig} style={{ height: "80%" }}>
                            <div className="sfinfo-section">
                                <div className="component" style={{ minHeight: "230px", borderRadius: ".5rem" }}>
                                    <DataGrid
                                        dataSource={ciList}
                                        allowColumnReordering={true}
                                        showBorders={true}
                                        {...gridConfig}
                                    >
                                        <Column
                                            dataField="id"
                                            caption="Id"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="kaizenTitle"
                                            caption="Title"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="category"
                                            caption="Category"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="cell"
                                            caption="Cell"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="lines"
                                            caption="Lines"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="status"
                                            caption="Status"
                                            dataType="text"
                                            allowEditing={false}
                                            cellRender={cellRenderStatus}
                                            minWidth={160}
                                        />
                                        <Column
                                            dataField="raisedBy"
                                            caption="Raised By"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="raisedON"
                                            caption="Raised On"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="dueDate"
                                            caption="Due Date"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="collaborated"
                                            caption="Collaborated"
                                            dataType="text"
                                            allowEditing={false}
                                        />
                                        <Column
                                            dataField="completedDate"
                                            caption="Completed Date"
                                            //dataType="text"
                                            visible={false}
                                        />
                                        <Column
                                            caption="Edit"
                                            fixed={true} type="buttons" minWidth={50} height="100%" showInColumnChooser={false}
                                        >
                                            <Button icon="edit" onClick={(data) => redirect(data.row.data.id)} />
                                        </Column>
                                    </DataGrid>
                                </div>
                            </div>
                        </ScrollView>
                    </div>
                </div>
            </section>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Footer showThemeSwitch={true} container="admin-console" hideSiteCount={true} activeSites={[]} sbg={[]} />
            </div>
        </>
    )
}

export default CIList